import { Button, Form, Modal, Spinner } from "react-bootstrap";
import Select from "react-select";
import { useEffect, useReducer, useState } from "react";
import dayjs from "dayjs";
import { defineValueInInput, getValueFromInput } from "../../../components/funcForInput";
import { ApiEndpoints, reqGetNew, reqPostNew } from "../../../config/apiClient";
import { toast } from "react-toastify";

export default function ModalRondaMapaFiltros({ show, handleClose, handleChangeFiltros, handleChangeRegistros, handleChangeDatas, filtroDados }: iProps) {
    useEffect(() => {
        carregarFiltros();
        // eslint-disable-next-line
    }, []);

    const [loading, setLoading] = useState<boolean>(false);
    const [_, forceUpdate] = useReducer((x) => x + 1, 0);

    // const [empresasOptions, setOptionsEmpresas] = useState<any>([]);
    const [centrosOptions, setOptionsCentros] = useState<any[]>([]);
    const [colaboradoresOptions, setOptionsColaboradores] = useState<any[]>([]);

    async function carregarFiltros() {
        const data_atual = dayjs();
        const data_inicial = data_atual.startOf("month").format("YYYY-MM-DD");
        const data_final = data_atual.endOf("month").format("YYYY-MM-DD");
        defineValueInInput("data_inicial", data_inicial);
        defineValueInInput("data_final", data_final);

        setLoading(true);
        const api = await reqGetNew(ApiEndpoints.qrcodeRegistrosFiltros);
        if (api.status === 200) {
            const dados = api.data;
            // let empresasAux = dados.empresas.map((item: any, index: any) => ({
            //     value: `${item.codigo}`,
            //     label: `${item.nome}`,
            // }));
            // setOptionsEmpresas(empresasAux);
            let centrosAux = dados.centros_custo.map((item: any, index: any) => ({
                value: `${item.codigo}`,
                label: `${item.codigo} - ${item.centro_custo}`,
            }));
            setOptionsCentros(centrosAux);
            let colsAux = dados.colaboradores.map((item: any, index: any) => ({
                value: `${item.id_colaborador}`,
                label: `${item.matricula} - ${item.nome_completo}`,
            }));
            setOptionsColaboradores(colsAux);
        }
        setLoading(false);
    }
    function handleChangeDias(direcao: "passado" | "futuro", qtd: "dia" | "mes") { 
        if (filtroDados.data_inicial.length !== 10 || filtroDados.data_final.length !== 10) { 
            return
        }
        const data_inicial = dayjs(filtroDados.data_inicial)
        // const data_final = dayjs(filtroDados.data_final)
        if (qtd === "dia") { 
            let inicial = ""
            let final = ""
            if (direcao === "passado") { 
                inicial = data_inicial.subtract(1, 'day').format("YYYY-MM-DD")
                final = inicial
            }
            if (direcao === "futuro") { 
                inicial = data_inicial.add(1, 'day').format("YYYY-MM-DD")
                final = inicial
            }
            handleChangeDatas(inicial, final)
            forceUpdate();
            return
        }
        if (qtd === "mes") { 
            let data_inicial_aux = dayjs(`${data_inicial.format("YYYY-MM")}-01`)
            let data_final_aux = data_inicial_aux.endOf('month')
            let inicial = data_inicial_aux.format("YYYY-MM-DD")
            let final = data_final_aux.format("YYYY-MM-DD")
            if (inicial !== filtroDados.data_inicial || final !== filtroDados.data_final) {
                handleChangeDatas(inicial, final)
                forceUpdate();
                return
            }
            if (direcao === "passado") { 
                inicial = data_inicial_aux.subtract(1, 'day').startOf('month').format("YYYY-MM-DD")
                final = data_inicial_aux.subtract(1, 'day').endOf('month').format("YYYY-MM-DD")
            }
            if (direcao === "futuro") { 
                inicial = data_final_aux.add(1, 'day').startOf('month').format("YYYY-MM-DD")
                final = data_final_aux.add(1, 'day').endOf('month').format("YYYY-MM-DD")
            }
            handleChangeDatas(inicial, final)
            forceUpdate();
            return
        }
    }

    async function listarRegistros() {
        const filtro = {
            data_inicial: getValueFromInput("data_inicial"),
            data_final: getValueFromInput("data_final"),
            // id_empresa: empresasFiltro.map((item:any, index:any) => (Number(item.value))),
            // id_centro_custo: centrosFiltro.map((item:any, index:any) => (Number(item.value))),
            // id_colaborador: colaboradoresFiltro.map((item:any, index:any) => (Number(item.value))),
            id_empresa: filtroDados.id_empresa.map((item: any, index: any) => Number(item.value)),
            id_centro_custo: filtroDados.id_centro_custo.map((item: any, index: any) => Number(item.value)),
            id_colaborador: filtroDados.id_colaborador.map((item: any, index: any) => Number(item.value)),
        };
        if (String(filtro.data_inicial).length !== 10 && String(filtro.data_final).length !== 10) {
            toast.warning("Informe o período corretamente!", {
                containerId: 1,
                position: "top-center",
                theme: "dark",
                autoClose: 3000,
            });
            return;
        } else { 
            let data_inicial = dayjs(filtro.data_inicial)
            let data_final = dayjs(filtro.data_final)
            if (data_final.isBefore(data_inicial)) { 
                toast.warning("Data final não pode ser menor que inicial!", {
                    containerId: 1,
                    position: "top-center",
                    theme: "dark",
                    autoClose: 3000,
                });
                return;
            }
        }
        if (filtro.id_centro_custo.length === 0) {
            toast.warning("Selecione pelo menos algum centro de custo!", {
                containerId: 1,
                position: "top-center",
                theme: "dark",
                autoClose: 3000,
            });
            return;
        }

        setLoading(true);
        const api = await reqPostNew(ApiEndpoints.qrcodeRegistros, filtro);
        if (api.status === 200) {
            const registros: any[] = api.data;
            if (registros.length === 0) {
                toast.warning("Nenhum registro encontrado!", {
                    containerId: 1,
                    position: "top-center",
                    theme: "dark",
                    autoClose: 3000,
                });
                handleChangeRegistros([]);
            } else {
                handleChangeRegistros(api.data);
            }
        }
        setLoading(false);
    }

    return (
        <Modal show={show} onHide={handleClose} backdrop="static" keyboard={true} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Consultar Registros de Ronda</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <span style={{ display: "none" }}>{String(_)}</span>
                <div className="div-row">
                    <Button size="sm" variant="secondary" className="div-row" style={{ height: "30px", margin: "0px 5px 0px 0px", padding: "0px 10px" }} onClick={() => {handleChangeDias("passado", "mes")}}>
                        <span className="material-symbols-outlined" style={{ fontSize: "14px" }}>
                            arrow_back
                        </span>
                        <span style={{ fontSize: "12px" }}> Mês</span>
                    </Button>
                    <Button size="sm" variant="secondary" className="div-row" style={{ height: "30px", margin: "0px 5px 0px 0px", padding: "0px 10px" }} onClick={() => {handleChangeDias("passado", "dia")}}>
                        <span className="material-symbols-outlined" style={{ fontSize: "14px" }}>
                            arrow_back
                        </span>
                        <span style={{ fontSize: "12px" }}> Dia</span>
                    </Button>
                    <Form.Control
                        name="data_inicial"
                        type="date"
                        id="data_inicial"
                        value={filtroDados.data_inicial}
                        placeholder="Data Inicial"
                        style={inputDatas}
                        onChange={(event) => {
                            handleChangeFiltros(event.target.value, "inicial");
                            forceUpdate();
                        }}
                    />
                    <Form.Control
                        name="data_final"
                        type="date"
                        id="data_final"
                        value={filtroDados.data_final}
                        placeholder="Data Final"
                        style={inputDatas}
                        onChange={(event) => {
                            handleChangeFiltros(event.target.value, "final");
                            forceUpdate();
                        }}
                    />
                    <Button size="sm" variant="secondary" className="div-row" style={{ height: "30px", margin: "0px 5px 0px 0px", padding: "0px 10px" }} onClick={() => {handleChangeDias("futuro", "dia")}}>
                        <span style={{ fontSize: "12px" }}> Dia</span>
                        <span className="material-symbols-outlined" style={{ fontSize: "14px" }}>
                            arrow_forward
                        </span>
                    </Button>
                    <Button size="sm" variant="secondary" className="div-row" style={{ height: "30px", margin: "0px 5px 0px 0px", padding: "0px 10px" }} onClick={() => {handleChangeDias("futuro", "mes")}}>
                        <span style={{ fontSize: "12px" }}> Mês</span>
                        <span className="material-symbols-outlined" style={{ fontSize: "14px" }}>
                            arrow_forward
                        </span>
                    </Button>
                </div>
                <br></br>
                <div className="div-row">
                    {/*<Select
                        name="ids_empresas"
                        id="ids_empresas"
                        options={empresasOptions}
                        defaultValue={filtroDados.id_empresa}
                        value={filtroDados.id_empresa}
                        placeholder="Empresas"
                        isMulti
                        closeMenuOnSelect={false}
                        onChange={(choice) => {
                            handleChangeFiltros(choice, "empresa");
                            forceUpdate();
                        }}
                        styles={styleSelectEmpresas}
                    />*/}
                    <Select
                        name="ids_centro_custo"
                        id="ids_centro_custo"
                        options={centrosOptions}
                        defaultValue={filtroDados.id_centro_custo}
                        value={filtroDados.id_centro_custo}
                        placeholder="Centros de Custo"
                        isMulti
                        closeMenuOnSelect={false}
                        onChange={(choice: any) => {
                            handleChangeFiltros(choice, "centro");
                            forceUpdate();
                        }}
                        styles={styleSelectCentros}
                    />
                </div>
                <br></br>
                <div className="div-row">
                    <Select
                        name="ids_colaboradores"
                        id="ids_colaboradores"
                        options={colaboradoresOptions}
                        defaultValue={filtroDados.id_colaborador}
                        value={filtroDados.id_colaborador}
                        placeholder="Colaboradores"
                        isMulti
                        closeMenuOnSelect={false}
                        onChange={(choice: any) => {
                            handleChangeFiltros(choice, "colaborador");
                            forceUpdate();
                        }}
                        styles={styleSelectCentros}
                    />
                </div>
                <br></br>
                <div className="div-row">
                    <Button
                        onClick={() => {
                            listarRegistros();
                        }}
                        variant="primary"
                        disabled={loading}
                        style={{ height: "40px", marginRight: "5px" }}
                        className="div-row-space-between"
                    >
                        Consultar <span className="material-symbols-outlined">filter_alt</span>
                    </Button>
                    {/*<Button
                        onClick={() => {
                            // handleShowModalDownload();
                        }}
                        disabled={loading}
                        variant="success"
                        style={{ height: "40px", marginRight: "5px" }}
                        className="div-row-space-between"
                    >
                        Relatório{" "}
                        <span className="material-symbols-outlined" style={{ marginLeft: "5px" }}>
                            download_for_offline
                        </span>
                    </Button>*/}
                    {loading && <Spinner animation="border" role="status"></Spinner>}
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Fechar
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
interface iProps {
    show: boolean;
    handleClose: any;
    handleChangeFiltros: any;
    handleChangeDatas: any;
    filtroDados: any;
    handleChangeRegistros: any;
}

// const styleSelectEmpresas = {
//     control: (baseStyles: any, state: any) => ({
//         ...baseStyles,
//         width: "250px",
//         borderColor: "#dee2e6",
//         minHeight: "39px",
//         maxHeight: "120px",
//         marginRight: "5px",
//         fontSize: "14px",
//     }),
//     valueContainer: (provided: any, state: any) => ({
//         ...provided,
//         minHeight: "30px",
//         maxHeight: "120px",
//         overflowY: "auto",
//         fontSize: "14px",
//     }),
//     input: (provided: any, state: any) => ({
//         ...provided,
//         margin: "0px",
//         fontSize: "14px",
//     }),
//     indicatorSeparator: (state: any) => ({
//         display: "none",
//         fontSize: "14px",
//     }),
//     indicatorsContainer: (provided: any, state: any) => ({
//         ...provided,
//         minHeight: "39px",
//         maxHeight: "120px",
//         fontSize: "14px",
//     }),
//     menu: (provided: any, state: any) => ({
//         ...provided,
//         fontSize: "14px",
//     }),
// };
const styleSelectCentros = {
    control: (baseStyles: any, state: any) => ({
        ...baseStyles,
        width: "400px",
        borderColor: "#dee2e6",
        minHeight: "39px",
        maxHeight: "120px",
        marginRight: "5px",
        fontSize: "14px",
    }),
    valueContainer: (provided: any, state: any) => ({
        ...provided,
        minHeight: "30px",
        maxHeight: "120px",
        overflowY: "auto",
        fontSize: "14px",
    }),
    input: (provided: any, state: any) => ({
        ...provided,
        margin: "0px",
        fontSize: "14px",
    }),
    indicatorSeparator: (state: any) => ({
        display: "none",
        fontSize: "14px",
    }),
    indicatorsContainer: (provided: any, state: any) => ({
        ...provided,
        minHeight: "39px",
        maxHeight: "120px",
        fontSize: "14px",
    }),
    menu: (provided: any, state: any) => ({
        ...provided,
        fontSize: "14px",
    }),
};
const inputDatas: React.CSSProperties = {
    height: "41px",
    marginRight: "5px",
    maxWidth: "max-content",
};
